import app from "../_app";

const gallery = document.querySelector('.js-product-gallery');
const backdrop = document.querySelector('.js-gallery-backdrop');

if(gallery) {
    const updateCurrent = (newCurrent) => {
        [...gallery.querySelectorAll('[data-current]')].map(item => item.removeAttribute('data-current'));
        [...gallery.querySelectorAll(`[data-index="${newCurrent}"]`)].map(item => item.setAttribute('data-current', ''));
    }

    const galleryHandler = (index, close) => {
        if(gallery.hasAttribute('data-open') && close){
            app.unlockBody();
            gallery.removeAttribute('data-open');
            if(backdrop) backdrop.removeAttribute('data-open');
        }else {
            if(!gallery.hasAttribute('data-open')) {
                app.lockBody();
                gallery.setAttribute('data-open', '');
                if(backdrop) backdrop.setAttribute('data-open', '');
            }
            const track = gallery.querySelector('.js-slider-track');
            const slides = gallery.querySelectorAll('.col-12');
            const targetSlide = slides[index];

            if(targetSlide && track) {
                // Desktop uses CSS transform, mobile uses scrollTo
                if(app.viewport.isEqualOrGreaterThan('lg')) {
                    track.style.setProperty('--x', `${-targetSlide.offsetLeft}px`);
                } else {
                    track.scrollTo({left: targetSlide.offsetLeft, behavior: 'smooth'});
                }
            }
            updateCurrent(index);
        }
    };

    const triggers = [...document.querySelectorAll('.js-gallery-trigger')];
    const videoTriggers = [...document.querySelectorAll('.js-gallery-video-trigger')];
    const closeTrigger = document.querySelector('.js-gallery-close');

    triggers.map(trigger => trigger.addEventListener('click', () => {
        galleryHandler(trigger.getAttribute('data-number'));
    }));
    videoTriggers.map(videoTrigger => videoTrigger.addEventListener('click', () => {
        galleryHandler(videoTrigger.getAttribute('data-number'));
    }));

    closeTrigger.addEventListener('click',() => galleryHandler(0, true));

    // Close gallery when clicking on backdrop
    if(backdrop) {
        backdrop.addEventListener('click', () => galleryHandler(0, true));
    }

    // Use capture phase to handle keyboard events BEFORE slider.js
    document.addEventListener('keydown', function(e) {
        if(gallery.hasAttribute('data-open') && (e.key === 'ArrowLeft' || e.key === 'ArrowRight' || e.key === 'Escape')) {
            // Stop the event from reaching slider.js
            e.stopImmediatePropagation();
            e.preventDefault();

            const allSlides = [...gallery.querySelectorAll('.col-12')];
            // Find current slide by checking which dot has data-current attribute
            const currentDot = gallery.querySelector('[data-current]');
            const current = currentDot ? parseInt(currentDot.getAttribute('data-index')) : 0;
            const max = allSlides.length;

            switch (e.key) {
                case 'Escape':
                    app.unlockBody();
                    gallery.removeAttribute('data-open');
                    if(backdrop) backdrop.removeAttribute('data-open');

                    if(gallery.querySelector('iframe')) {
                        gallery.querySelector('iframe').click();
                    }
                    break;
                case 'ArrowLeft':
                    if (current > 0) {
                        galleryHandler(current - 1, false);
                    } else {
                        // Wrap to last slide
                        galleryHandler(max - 1, false);
                    }
                    break;
                case 'ArrowRight':
                    if (current < (max - 1)) {
                        galleryHandler(current + 1, false);
                    } else {
                        // Wrap to first slide
                        galleryHandler(0, false);
                    }
                    break;
            }
        }
    }, true);

    const loadYouTubeApi = () => {
        if (window.YT && typeof window.YT.Player === 'function') {
            return Promise.resolve(window.YT);
        }

        if (window.__ytApiPromise) {
            return window.__ytApiPromise;
        }

        window.__ytApiPromise = new Promise((resolve, reject) => {
            const existingScript = document.querySelector('script[src*="youtube.com/iframe_api"]');
            const previousCallback = window.onYouTubeIframeAPIReady;
            let resolved = false;

            const resolveApi = () => {
                if (!resolved && window.YT && typeof window.YT.Player === 'function') {
                    resolved = true;
                    resolve(window.YT);
                }
            };

            window.onYouTubeIframeAPIReady = () => {
                if (typeof previousCallback === 'function') {
                    previousCallback();
                }
                resolveApi();
            };

            if (!existingScript) {
                const script = document.createElement('script');
                script.src = 'https://www.youtube.com/iframe_api';
                script.async = true;
                script.onerror = () => reject(new Error('Failed to load YouTube API'));
                document.head.appendChild(script);
            } else {
                existingScript.addEventListener('load', resolveApi, { once: true });
            }

            if (window.YT && typeof window.YT.ready === 'function') {
                window.YT.ready(resolveApi);
            }
        });

        return window.__ytApiPromise;
    };

    const playerNode = gallery.querySelector('#player');

    if (playerNode) {
        const embedCode = playerNode.dataset.code;
        const galleryCloseTrigger = gallery.querySelector('.js-gallery-close');
        let player = null;

        const stopVideo = () => {
            if (!player || typeof player.pauseVideo !== 'function') {
                return;
            }

            player.pauseVideo();
            if (typeof player.seekTo === 'function') {
                player.seekTo(0);
            }
        };

        loadYouTubeApi()
            .then((YT) => {
                player = new YT.Player('iframe-video', {
                    videoId: embedCode,
                    playerVars: {
                        rel: '0'
                    },
                    events: {
                        onReady: () => {}
                    }
                });
            })
            .catch(() => {
                // Keep gallery usable even if YouTube API fails to load.
            });

        if (galleryCloseTrigger) {
            galleryCloseTrigger.addEventListener('click', stopVideo);
        }

        document.addEventListener('keydown', function(e) {
            if(e.key === 'Escape') {
                stopVideo();
            }
        });
    }




}